import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import Loader from '../../shared/components/Loader'
import PaneWrapper from '../components/PaneWrapper'
import Pane from '../components/Pane'

@inject('guidedTour', 'program', 'auth') @observer
class PaneContainer extends Component {

  static propTypes = {
    auth: PropTypes.object,
    guidedTour: PropTypes.object,
    program: PropTypes.object,
  }

  componentWillMount() {
    const { guidedTour, program } = this.props

    if (!program.loading && program.collection.length < 2) {
      program.load({ reset: true })
    }
    // reload if the length is currently below 2 which indicates that only
    // a single model was loaded sofar
    if (!guidedTour.loading && guidedTour.collection.length < 2) {
      this.load()
    }
  }

  load() {
    const { guidedTour } = this.props
    if (!guidedTour.loading) {
      guidedTour.load({ reset: true })
    }
  }

  @autobind
  handleLoad() {
    this.load()
  }

  render() {
    const { guidedTour, program } = this.props

    if (guidedTour.loading || program.loading) {
      return (
        <PaneWrapper>
          <Loader>Führungen werden geladen...</Loader>
        </PaneWrapper>
      )
    }

    return (
      <Pane
        onLoad={this.handleLoad}
        canCreateGuidedTour={!!program.collection.filter((prog) => prog.isLive).length}
        data={guidedTour}
      />
    )
  }

}

const PaneContainerWithRouter = withRouter(PaneContainer)

export { PaneContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/guided-tour/containers/Pane.js